import styled, { useTheme } from 'styled-components'
import { ImageAsset } from '@/components/common'
import { Typo } from '@/components/common/typography'
import ModalSliderDefault from '@/components/domains/order2/modal-slider-default'
import { GlobalColorEnum } from '@/constants/global-color.enum'
import { SHIPPING_REQUEST_LIST } from '@/constants/legacy/constData'
import { UseModalProps } from '@/containers/hooks/useModal'

interface ModalShippingAddressSelectProps {
  title: string
  useModalProps: UseModalProps<any>
  selectedShippingRequest: { id: number; message: string } | undefined
  onSelectedShippingRequestChange: (item: { id: number; message: string }) => void
}

export const ModalShippingAddressSelect = ({
  title,
  useModalProps,
  selectedShippingRequest,
  onSelectedShippingRequestChange,
}: ModalShippingAddressSelectProps) => {
  const { color } = useTheme()

  const handleSelect = (item: { id: number; message: string }) => {
    onSelectedShippingRequestChange(item)
    useModalProps.hideModal()
  }

  return (
    <ModalSliderDefault title={title} centerTitle useModalProps={useModalProps} titleNoBorder>
      <StyledListContainer>
        {SHIPPING_REQUEST_LIST.map((item, index) => {
          const selected = selectedShippingRequest?.id === index + 1
          return (
            <StyledItem key={item.id} selected={selected} onClick={() => handleSelect(item)}>
              <Typo variant="Body2 Regular" color={selected ? color.blue500 : color.gray900}>
                {item.message}
              </Typo>
              {selected && <ImageAsset name="ic_check_16" size={24} svg />}
            </StyledItem>
          )
        })}
      </StyledListContainer>
    </ModalSliderDefault>
  )
}

const StyledListContainer = styled.div`
  margin-bottom: calc(env(safe-area-inset-bottom) + 4rem);
  display: flex;
  flex-direction: column;
`

const StyledItem = styled.div<{ selected: boolean }>`
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => props.theme.color.grayWhite};
  cursor: pointer;
  :not(:last-child) {
    border-bottom: 1px solid ${GlobalColorEnum.Gray70};
  }
`
